import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dceebed&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0dceebed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dceebed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dceebed')) {
      api.createRecord('0dceebed', component.options)
    } else {
      api.reload('0dceebed', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dceebed&scoped=true", function () {
      api.rerender('0dceebed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/lottery/index.vue"
export default component.exports